import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { UserDetails, UserInput } from '../models/data-cleanup-model';
import { IAppConfig } from "../core/models/app-config.model";
import { AppConfig } from "../design/app";
@Injectable({
    providedIn: 'root'
})
export class DataCleanUpService {
    appConfig: any;
    baseUrl: string;

    constructor(private http: HttpClient) {
        this.appConfig = AppConfig;
        this.baseUrl = this.appConfig.dataCleanUp.baseUrl;
    }

    public getUserDetails(userInput: UserInput): Observable<any> {
        const getUserDetails = this.appConfig.dataCleanUp.getUserDetails;
        const apiUrl: string = `${this.baseUrl + getUserDetails}`;
        return this.http.post(apiUrl, userInput).pipe(
            map(response => {
                return response
            }),
            catchError(this.handleError)
        );
    }

    //public updateMobileNo(userDetails: UserDetails): Observable<any> {
    //    const dataCleanUp = this.appConfig.dataCleanUp.dataCleanUp;
    //    let apiUrl: string = `${this.baseUrl + dataCleanUp}?userinput=1`;
    //    return this.http.post(apiUrl, userDetails).pipe(
    //        map((response: any) => response),
    //        catchError(this.handleError)
    //    );
    //}

    public updateMaskNResetAssessment(userDetails: UserDetails, userinput: number): Observable<any> {
        const dataCleanUp = this.appConfig.dataCleanUp.dataCleanUp;
        const apiUrl: string = `${this.baseUrl + dataCleanUp}?userinput=` + `${userinput}`;
        console.log(apiUrl);
        return this.http.post(apiUrl, userDetails).pipe(
            map((response: any) => response),
            catchError(this.handleError)
        );
    }

    private handleError(error: HttpErrorResponse) {
        if (error.status == 400) {
            return "N"
        }
        if (error.error instanceof ErrorEvent) {
            console.error('An error occurred:', error.error.message);
        } else {
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }
        return throwError(
            'Something bad happened; please try again later.');
    };
}
